export const setCookieByName = (state, cname) => {
    var date = new Date();
    if (cname === 'b__ck') {
        date.setTime(date.getTime() + (3600 * 1000 * 24 * 30));
    } if (cname === 'b__lg') {
        date.setTime(date.getTime() + (3600 * 1000 * 24 * 365));
    } else {
        date.setTime(date.getTime() + (1 * 24 * 60 * 60 * 1000));
    }
    var expires = "; path=/; expires=" + date.toGMTString();
    var cookie = `${cname}=${btoa(JSON.stringify(state))}${expires}`;
    document.cookie = cookie;
}